const { makeStyles } = require("@material-ui/core");

const useCommonStyles = makeStyles(theme => ({
    avatarLarge: {
        height: 65,
        width: 65,
    },
}));

export default useCommonStyles;